module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Dedication.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "pl-center"
  }, [_vm._v("To the fabulous Sharon Kendrick, who sorted out what was wrong with an early draft of this book on a long, rainy, Irish drive to and from Sligo town (and an atmospheric tour of Yeats country)—both of which amounted to a master class in writing for the Harlequin Presents line.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-center"
  }, [_vm._v("And to Abby Green, Heidi Rice, Fiona Harper and Chantelle Shaw, for our inspiring days in Delphi. ")]), _vm._v(" "), _c('p', {
    staticClass: "pl-center"
  }, [_vm._v("And to all the readers who wrote me to ask for Nikolai’s story. This is for you most of all!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5ae74a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dedication.vue
// module id = 75
// module chunks = 0